"use client";
import { Mask } from "antd-mobile";
import clsx from "clsx";
import {
    forwardRef,
    PropsWithChildren,
    ReactNode,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";

type Props = {
    title?: string | ReactNode;
    onBeforeClose?: () => void;
    getContainer?: any;
    className?: string; // 自定义样式类名，用于覆盖默认样式，如：bg-[#fff] text-[#000] 等
    visible?: boolean;
    position?: "center" | "bottom";
    onChange?: (visible: boolean) => void;
    useClose?: boolean;
};
export type ModalProps = {
    onClose: () => void;
    onOpen: () => void;
};
const TipsModal = forwardRef<ModalProps, PropsWithChildren<Props>>(function TipsModal(props, ref) {
    const {
        children,
        title,
        onBeforeClose,
        className,
        position = "center",
        onChange,
        visible,
        useClose = true,
    } = props;

    const [innerVisible, setInnerVisible] = useState<boolean>(visible || false);
    useImperativeHandle(ref, () => {
        return {
            onClose: () => setInnerVisible(false),
            onOpen: () => setInnerVisible(true),
        };
    });

    useEffect(() => {
        if (typeof onChange === "function") {
            onChange(innerVisible);
        }
    }, [innerVisible]);

    useEffect(() => {
        setInnerVisible(!!visible);
    }, [visible]);

    return (
        <Mask
            visible={innerVisible}
            onMaskClick={() => setInnerVisible(false)}
            getContainer={props?.getContainer}
        >
            <div
                className={clsx("flex h-[100dvh] h-[100vh] justify-center", className, {
                    "items-center": position === "center",
                    "items-end": position === "bottom",
                })}
            >
                <div className="mask-box w-[3.4rem] rounded-[10px] bg-[#1f2830] p-[0.1389rem]">
                    <div className={"title mb-[10px] flex"}>
                        <div className="flex-1 text-center text-[0.18rem] font-bold text-[#009d81]">
                            {title}
                        </div>
                        {useClose && (
                            <span
                                className="iconfont icon-guanbi closeIcon"
                                onClick={() => {
                                    onBeforeClose && onBeforeClose();
                                    setInnerVisible(false);
                                }}
                            ></span>
                        )}
                    </div>
                    <div className="popUpMain">{children}</div>
                </div>
            </div>
        </Mask>
    );
});

export default TipsModal;
